import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Link } from 'react-router-dom';
import { getStaticFilesBaseUrl } from '../../System/systemConfig';
import { userViewProfilePath } from '../../UserView';
import { radioEinsLoadWeeklyComment } from '../actions';
import { radioEinsWeeklyCommentSelector } from '../selectors';
import { LoadingIndicatorSpinner } from '../../common/LoadingIndicatorSpinner';

export const WeeklyComment = () => {
    const weeklyComment = useSelector(radioEinsWeeklyCommentSelector);

    const dispatch = useDispatch();

    useEffect(() => {
        dispatch(radioEinsLoadWeeklyComment());
    }, [dispatch]);

    return (
        <>
            <div className="">
                <div className="p-1" style={{fontSize: '13px'}}>
                    <div className="textbox title">
                        <span className="text-primary" style={{fontSize: '11px'}}>Kommentar</span>
                        <h5 style={{fontSize: '20px', fontWeight: 'bold'}}>Der aktuelle Kommentar</h5>
                        von <Link to={userViewProfilePath('3893018')}>Andreas Ulrich</Link>
                    </div>
                    <div>
                        <Link to={userViewProfilePath('3893018')} title="Andreas Ulrich - Profil">
                            <img
                                className="img-fluid"
                                src={getStaticFilesBaseUrl() + '/r1/andreas_ulrich.jpg'}
                                alt="Andreas Ulrich - Profil"
                            />
                        </Link>
                    </div>
                    <div className="textbox body pt-2">{(weeklyComment && weeklyComment.comment) || <LoadingIndicatorSpinner/>}</div>
                    <div className="textbox footer"></div>
                </div>
            </div>
        </>
    );
};
